import React, { useEffect, useRef } from 'react';
import _ from 'lodash';

import Tippy from '../ReactTippy';
import { iosCheck } from '../../utilities/stringUtil';

const headers = [
  { name: '姓名', valueString: 'fullname', defaultValue: '' },
  { name: 'かな', valueString: 'fullname_kana', defaultValue: '' },
  { name: '生年月日', valueString: 'birthday', defaultValue: '' },
  { name: 'CCUS技能者ID', valueString: 'ccus_engineer_id', defaultValue: '' },
  {
    name: '支店',
    valueString: 'partner_company_branch.name',
    defaultValue: '本社',
  },
];

export const UpdatePartnerCompanyBranchWorkersTable = ({
  workers,
  maxHeightBody = 243,
}) => {
  const refTable = useRef();
  const refBody = useRef();

  useEffect(
    () => {
      if (
        refTable.current &&
        refBody.current &&
        !iosCheck() &&
        refBody.current.scrollHeight > refBody.current.offsetHeight
      ) {
        refTable.current.classList.add(
          'update-partner-company-branch-workers-table__scroll'
        );
      }
    },
    [workers]
  );

  const renderToolTip = value => (
    <Tippy
      duration={10}
      distance={24}
      arrowType='sharp'
      delay={[500, 0]}
      placement='bottom'
      followCursor={true}
      role={`tippy_target_${_.uniqueId()}`}
      html={renderTooltipContent(value)}
    >
      <p className='value-table__txt--7'>{value}</p>
    </Tippy>
  );

  return (
    <table
      className='table update-partner-company-branch-workers-table'
      ref={refTable}
    >
      <thead className='table__header'>
        <tr className='table__label'>
          {_.map(headers, (item, index) => (
            <td
              className='value-table value-table--table__label update-partner-company-branch-workers-table__value-table'
              key={index}
            >
              <div className='value-table__label update-partner-company-branch-workers-table__header-label'>
                {item.name}
              </div>
            </td>
          ))}
        </tr>
      </thead>
      <tbody
        className='table__body'
        style={{ maxHeight: maxHeightBody }}
        ref={refBody}
      >
        {_.map(workers, (item, index) => (
          <tr className='table__item' key={index}>
            {_.map(headers, ({ valueString, defaultValue }) => (
              <td className='value-table update-partner-company-branch-workers-table__value-table'>
                {renderToolTip(_.get(item, valueString, defaultValue))}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const renderTooltipContent = data => {
  const rowStyle = {
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
    maxWidth: '240px',
  };

  return (
    <React.Fragment>
      <div style={rowStyle}>{data}</div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/tables/UpdatePartnerCompanyBranchWorkersTable.jsx